import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {
    searchTargetingInterestsWithSearchCriteria,
    updateSingleTargetingInterest
} from "../../services/facebook-targeting-interest-data.service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {TARGETING_INTEREST_FIELDS_LIST} from "../../constants/targeting-interest.constant";
import {SAVE_PARENT_PRODUCT_TIME_DELAY} from "../../../pod/constants/pod.constant";
import {updateSingleParentProduct} from "../../../pod/services/parent-product-data-service";
import {SAVE_DATA_TIME_DELAY} from "../../constants/facebook-constant";

const TargetingInterestsList = ({
                                    facebookTargetingInterest,
                                    setFacebookTargetingInterest,
                                    campaignInterests = {},
                                    setCampaignInterests = undefined,
                                }) => {
    const [targetingInterestsList, setTargetingInterestsList] = useState([]);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(false);
    const [relevantInterestsList, setRelevantInterestsList] = useState([]);
    let [changesCount, setChangesCount] = useState(0);

    useEffect(() => {
        if (facebookTargetingInterest?.id) {
            processTargetingInterests(facebookTargetingInterest, true);
        } else {
            setTargetingInterestsList([]);
            setRelevantInterestsList([]);
        }
    }, [facebookTargetingInterest?.id, facebookTargetingInterest?.relevantInterests]);

    useEffect(() => {
        if (facebookTargetingInterest?.id) {
            processTargetingInterests(facebookTargetingInterest, true, false);
        } else {
            setTargetingInterestsList([]);
            setRelevantInterestsList([]);
        }
    }, [facebookTargetingInterest?.relevantInterests]);

    const processTargetingInterests = (existingFacebookTargetingInterest, isFirst = false, processCampaignInterests = true) => {
        let existingInterests = _.values(existingFacebookTargetingInterest?.interests) || [];
        const relevantInterestsList = existingFacebookTargetingInterest?.relevantInterests || [];

        _.forEach(existingInterests, (interest) => {
            interest.isRelevant = _.includes(relevantInterestsList, interest?.id);
        });

        existingFacebookTargetingInterest.interests = _.keyBy(existingInterests, 'id');

        setFacebookTargetingInterest(existingFacebookTargetingInterest);

        existingInterests = _.map(existingInterests, (interest) => {
            interest.pathText = interest?.path?.join(' > ');
            return interest;
        });

        setTargetingInterestsList(_.orderBy(existingInterests, ['isRelevant', 'name'], ['desc', 'asc']));
        setRelevantInterestsList(relevantInterestsList || []);

        if (!isFirst) {
            incrementChangesCount();
        }

        if (setCampaignInterests && processCampaignInterests) {
            let existingCampaignInterests = {...campaignInterests};
            let allInterests = existingCampaignInterests['all'];

            allInterests = _.uniq(_.compact(_.concat(allInterests, relevantInterestsList)));
            existingCampaignInterests[facebookTargetingInterest?.designId] = relevantInterestsList;
            existingCampaignInterests['all'] = allInterests;
            setCampaignInterests(existingCampaignInterests);
        }
    }

    const addRelevantInterest = (interest) => {
        const existingFacebookTargetingInterest = {...facebookTargetingInterest};
        existingFacebookTargetingInterest.relevantInterests = [...relevantInterestsList, interest?.id];
        processTargetingInterests(existingFacebookTargetingInterest);
    }

    const removeRelevantInterest = (interest) => {
        const existingFacebookTargetingInterest = {...facebookTargetingInterest};
        existingFacebookTargetingInterest.relevantInterests = _.filter(relevantInterestsList, (relevantInterest) => relevantInterest !== interest?.id);
        processTargetingInterests(existingFacebookTargetingInterest);
    }

    const saveTargetInterest = async () => {
        setDataFetchInProgress(true);

        const existingFacebookTargetingInterest = {...facebookTargetingInterest};
        existingFacebookTargetingInterest.relevantInterests = relevantInterestsList;

        processTargetingInterests(existingFacebookTargetingInterest, true);

        await updateSingleTargetingInterest(existingFacebookTargetingInterest);
        setFacebookTargetingInterest(existingFacebookTargetingInterest);

        setDataFetchInProgress(false);
    }

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {

                if (changesCount > 0) {
                    resetChangesCount();
                    await saveTargetInterest();
                }

            }, SAVE_DATA_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    }, [changesCount]);

    const triggerSaveChanges = () => {
        const timeoutId =
            setTimeout(async () => {

                if (changesCount > 0) {
                    resetChangesCount();
                    await saveTargetInterest();
                }

            }, SAVE_DATA_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    }

    const incrementChangesCount = () => {
        setChangesCount(++changesCount);
    }

    const resetChangesCount = () => {
        setChangesCount(0);
    }


    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Targeting Interests
                        <span
                            className={'ml-2 text-purple-600'}>({relevantInterestsList?.length}/{targetingInterestsList?.length})</span>
                    </div>

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/6 flex items-center justify-end">
                    {relevantInterestsList?.length > 0 &&
                        <button
                            className="button-green px-2 py-1"
                            onClick={saveTargetInterest}>
                            Save Changes {changesCount > 0 && <span
                            className="border border-green-50 bg-green-100 rounded-full text-green-600 text-sm px-1 py-0">{changesCount}</span>}
                        </button>
                    }
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4 table-container-medium overflow-y-scroll border border-gray-400 rounded-lg">

                    <ShowEmptyListMessage
                        dataList={targetingInterestsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Targeting Interests'}/>

                    {targetingInterestsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {TARGETING_INTEREST_FIELDS_LIST?.map((targetingInterestField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${targetingInterestField?.cssClass}`}>{targetingInterestField?.label}</th>
                                ))}
                                {/*<th className="p-2 border border-gray-400 bg-gray-400 text-white">
                                    Actions
                                </th>*/}
                            </tr>
                            </thead>
                            <tbody className="">
                            {targetingInterestsList?.map((targetingInterest, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {TARGETING_INTEREST_FIELDS_LIST?.map((targetingInterestField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${targetingInterestField?.cssClass}`}>
                                                {targetingInterestField?.optionsMap &&
                                                    <>{targetingInterestField?.optionsMap[targetingInterest[targetingInterestField?.attribute]]?.name}</>
                                                }

                                                {!targetingInterestField?.optionsMap &&
                                                    <div className={'items-center'}>
                                                        <div className={'flex justify-between items-center'}>
                                                            {!targetingInterestField?.isList &&
                                                                <> {targetingInterest[targetingInterestField?.attribute]}</>
                                                            }

                                                            {targetingInterestField?.isAction &&
                                                                <div className="flex justify-center ml-2 font-normal">
                                                                    <>
                                                                        {relevantInterestsList?.indexOf(targetingInterest?.id) > -1 &&
                                                                            <button
                                                                                className="button-sky-outline px-1 py-0 w-28"
                                                                                onClick={() => removeRelevantInterest(targetingInterest)}>
                                                                                Relevant
                                                                            </button>
                                                                        }

                                                                        {relevantInterestsList?.indexOf(targetingInterest?.id) === -1 &&
                                                                            <button
                                                                                className="button-red-outline px-1 py-0 w-28"
                                                                                onClick={() => addRelevantInterest(targetingInterest)}>
                                                                                Not Relevant
                                                                            </button>
                                                                        }
                                                                    </>
                                                                </div>
                                                            }
                                                        </div>

                                                        {targetingInterestField?.isList &&
                                                            <>
                                                                {_.join(targetingInterest[targetingInterestField?.attribute], ', ')}
                                                            </>
                                                        }

                                                        {targetingInterestField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm mt-2 font-normal'}>
                                                                {targetingInterest[targetingInterestField?.secondaryAttribute]}
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default TargetingInterestsList
